import { httpGet } from "@/api/connection";
import { Office } from "./offices.types";

export type GetOfficesQuery = {
  office_id?: number;
};

export type GetOfficesResponse = Office[];

export type GetOfficesFn = (
  options?: GetOfficesQuery
) => Promise<GetOfficesResponse>;

const getOffices: GetOfficesFn = async (options) => {
  const { office_id } = options || {};
  if (office_id) {
    return httpGet(`/offices/${office_id}`);
  }
  return httpGet("/offices");
};

export const OfficesAPI = {
  get: getOffices,
};
